import React from 'react';
import Navigation from './navigation';
import { UserProvider } from './context/userContext';
import { SnackbarProvider } from "./context/snackbar";
import { createTheme, ThemeProvider, StyledEngineProvider} from '@mui/material/styles';
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  overrides: {
    MuiCollapse: {
      entered: {
        height: "500px",
        overflow: "visible"
      }
    }
  },
  palette: {
    text: {
        primary:'#676767',
        secondary: '#000'
    }
  }
});


class App extends React.Component {
  
  render() {
    return (
      <StyledEngineProvider>
        <ThemeProvider theme={theme}>
          <UserProvider>
            <SnackbarProvider>
              <Navigation />
            </SnackbarProvider>
          </UserProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    )
  }
}

export default App;


